module.exports = __webpack_public_path__ + "static/img/banner_02.dd330319.png";